import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/OverviewHeight/OverviewHeight'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'
import { CaseDownloadCTAItem } from 'components/cases/common/CaseDownloadCTA'

// ファーストビュー
export const firstViewItemWhite = {
  breadcrumb: '利用者10％増 - UX/UI改善で転職成功に必須のアプリを開発',
  title1: '利用者10％増 - UX/UI改善で転職成功に必須のアプリを開発',
  company: '株式会社キャリアデザインセンター',
  introduction_text:
    '多角的な人材サービスを展開し、特にIT・Web業界や女性の転職支援に強みを持つ人材サービス企業、キャリアデザインセンターが提供する求職者向けの人材紹介サービス「type転職エージェント」。転職希望者が増える昨今、求人の多さだけでなく、サービスの使い勝手もユーザー獲得の重要な要素となっています。Aitriaは、そんなアプリのUX/UIデザインから開発、そして内製化まで一貫して支援しました。',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'UX/UI改善',
  tag2src: '/cases/uxui-improvement/',
  tag3text: '内製化支援',
  tag3src: '/cases/inhouse-support/',
  industryTagText: 'サービス',
  industryTagSrc: '/cases/service/',
  image: '/images/img/cases/cdc/mv.webp',
  movie: '',
  alt: '利用者10％増 - UX/UI改善で転職成功に必須のアプリを開発',
}

// プロジェクト概要
export const overviewTitle =
  '転職成功率アップのため、ユーザーにアプリを活用してほしい——もっと求職者に寄り添えるアプリに'

export const overviewItem: OverviewItems[] = [
  {
    text: '特に20代を中心とした若年層にとって、転職は当たり前の時代になりました。株式会社キャリアデザインセンター（以下、キャリアデザインセンター）は、こうした時代の変化を背景に、転職そのものをもっとワクワクする体験にし、転職活動全体をより良いものへと進化させたいという強い思いを抱いていました。',
  },
  {
    text: '「type転職エージェント」では、これまでもWebでサービスを利用しているユーザーと比べて、アプリを利用して転職活動を行っているユーザーの方が、企業の選考を通過しやすいというデータがありました。この事実から、アプリを使いやすくし、より頻繁に起動してもらうことでサービスとの接点が増え、結果的にユーザーのエンゲージメントを高められるのではないか、という仮説が生まれました。',
  },
  {
    text: 'しかし、リニューアル前のアプリは操作性が悪く、さらに動作も不安定であったため、ユーザーが積極的に利用するまでには至っていませんでした。そこで、より多くの転職希望者にアプリを活用してもらい、スムーズに転職活動を進められる環境を整えることを目指して、キャリアデザインセンターは、UX/UIデザインから開発まで一貫して支援できるAitriaに抜本的なアプリ改善を相談することにしました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'UXを見直す必要性',
        text: 'アプリ利用率が頭打ちになっており、UX領域からユーザー体験の根本的な見直しが必要だった。',
      },
      {
        title: '要件定義ノウハウの不足',
        text: '本質的な価値を捉えた要件定義ができるパートナーを探していた。',
      },
      {
        title: '将来的な内製化への備え',
        text: '将来的に開発の内製化を目指していた。',
      },
    ],
    solutions: [
      {
        title: 'ペルソナ設計と体験全体の再構築',
        text: 'エキスパートレビューと徹底的なヒアリングに基づき、ペルソナとカスタマージャーニーを設定してアプリのコンセプトを再定義。',
      },
      {
        title: '要件定義におけるデザインと開発の連携',
        text: 'デザインフェーズからエンジニアが参画し、ビジネスサイドの要求とユーザー目線を統合した要件定義を実施。',
      },
      {
        title: '内製化に向けたハイブリッド開発体制の構築',
        text: 'クライアントの開発チームと並走する「ハイブリッド開発体制」を構築し、技術的なノウハウを共有して内製化の土台を構築。',
      },
    ],
    outcomes: [
      {
        title: 'アプリストアの評価が大幅に向上 (2.9→4.5)',
      },
      {
        title: 'アプリ利用者が10%増加',
      },
      {
        title: '開発内製化に向けた確固たる土台を構築',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: 'ユーザー離れは、UX/UIで止められます。',
  description:
    'ユーザー調査・UX/UI設計・開発・内製化支援までを一貫して担い、"使われるアプリ"へと変えます。まずは、現在の課題やお悩みをお聞かせください。',
}

// 資料ダウンロード CTA
export const caseDownloadCTAItem: CaseDownloadCTAItem = {
  title: 'アプリ開発RFP作成のポイント',
  description: 'アプリ開発担当者向けに、失敗しないためのポイントをテンプレート付の1冊にまとめました',
  imageSrc: '/images/img/cases/cta_rfp.webp',
  href: '/download/rfp/',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
